import { toast } from "@replohq/lattice/components/toast/Toast";

export const BILLING_CONFETTI_EVENT = "billing-confetti";

export const showAgentBillingUpdateSuccessToast = (
  title?: string,
  options?: { showConfetti?: boolean },
) => {
  toast.success({
    title: title ?? "Plan updated",
    description: "Your subscription has been updated.",
  });

  if (options?.showConfetti) {
    window.dispatchEvent(new CustomEvent(BILLING_CONFETTI_EVENT));
  }
};
